/* Kari Built Ovens — theme interactions & scroll choreography */
(function () {
  "use strict";

  var root = document.documentElement;
  root.classList.remove("no-js");
  root.classList.add("js");

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches;
  }
  function clamp(v, a, b) {
    return v < a ? a : v > b ? b : v;
  }

  /* ---------------------------------------------------------------- */
  /*  Header + mobile menu                                            */
  /* ---------------------------------------------------------------- */
  var header = document.querySelector("[data-header]");
  var toggle = document.querySelector("[data-nav-toggle]");
  var links = document.querySelector("[data-nav-links]");
  if (toggle && links && header) {
    var menu = document.createElement("div");
    menu.className = "mobile-menu";
    menu.innerHTML = links.innerHTML;
    header.appendChild(menu);

    var scrim = document.createElement("div");
    scrim.className = "mobile-scrim";
    document.body.appendChild(scrim);

    function setMenu(open) {
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      menu.classList.toggle("open", open);
      scrim.classList.toggle("open", open);
      document.body.style.overflow = open ? "hidden" : "";
    }
    toggle.addEventListener("click", function () {
      setMenu(!menu.classList.contains("open"));
    });
    menu.addEventListener("click", function (e) {
      if (e.target.tagName === "A") setMenu(false);
    });
    scrim.addEventListener("click", function () {
      setMenu(false);
    });
  }

  /* ---------------------------------------------------------------- */
  /*  Simple reveal-on-scroll (entrance for .reveal)                  */
  /* ---------------------------------------------------------------- */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && !reduce) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("is-visible");
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    revealEls.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  /* ---------------------------------------------------------------- */
  /*  Scroll progress bar                                             */
  /* ---------------------------------------------------------------- */
  var bar = document.createElement("div");
  bar.className = "scroll-progress";
  bar.setAttribute("aria-hidden", "true");
  document.body.appendChild(bar);

  /* ---------------------------------------------------------------- */
  /*  Magnetic CTAs (hover-capable, motion-friendly only)            */
  /* ---------------------------------------------------------------- */
  if (!reduce && window.matchMedia("(hover: hover)").matches) {
    var magnets = document.querySelectorAll(
      ".hero-cta .btn-primary, .price-cta .btn-primary"
    );
    magnets.forEach(function (btn) {
      btn.addEventListener("mousemove", function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) * 0.4;
        var y = (e.clientY - (r.top + r.height / 2)) * 0.4;
        btn.style.transform = "translate(" + x + "px," + y + "px)";
      });
      btn.addEventListener("mouseleave", function () {
        btn.style.transform = "";
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /*  Gallery lightbox (opened from the About portrait)               */
  /* ---------------------------------------------------------------- */
  var mModal = document.querySelector("[data-moments-modal]");
  var mTrigger = document.querySelector("[data-moments-open]");
  if (mModal && mTrigger) {
    var mCloses = mModal.querySelectorAll("[data-moments-close]");
    var setMoments = function (open) {
      mModal.classList.toggle("is-open", open);
      mTrigger.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
      if (open) mModal.scrollTop = 0;
    };
    mTrigger.addEventListener("click", function () { setMoments(true); });
    Array.prototype.forEach.call(mCloses, function (el) {
      el.addEventListener("click", function () { setMoments(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mModal.classList.contains("is-open")) setMoments(false);
    });
  }

  /* ---------------------------------------------------------------- */
  /*  Pinned kit: the inclusion nearest screen-centre becomes active   */
  /*  (highlights its text + crossfades its matching image)            */
  /* ---------------------------------------------------------------- */
  var kitMedia = document.querySelector(".kit-media");
  var kitItems = Array.prototype.slice.call(document.querySelectorAll(".kit-item"));
  var kitFrames = kitMedia
    ? Array.prototype.slice.call(kitMedia.querySelectorAll(".kit-frame"))
    : [];
  var kitActive = -1;
  var capIcon, capName, capCur, capTot;

  function pad(n) {
    return n < 10 ? "0" + n : "" + n;
  }
  function setKitActive(i) {
    if (i === kitActive || i < 0 || i >= kitItems.length) return;
    kitActive = i;
    kitItems.forEach(function (el, idx) {
      el.classList.toggle("is-active", idx === i);
    });
    kitFrames.forEach(function (f, idx) {
      f.classList.toggle("is-shown", idx === i);
    });
    var item = kitItems[i];
    var iconSvg = item.querySelector(".kit-icon");
    var h3 = item.querySelector("h3");
    if (capIcon && iconSvg) capIcon.innerHTML = iconSvg.innerHTML;
    if (capName && h3) capName.textContent = h3.textContent;
    if (capCur) capCur.textContent = pad(i + 1);
    if (capTot) capTot.textContent = " / " + pad(kitItems.length);
  }

  if (kitMedia && kitItems.length) {
    var capEl = document.createElement("div");
    capEl.className = "kit-media-cap";
    capEl.innerHTML =
      '<div class="cap-main"><span class="cap-icon"></span><span class="cap-name"></span></div>' +
      '<span class="cap-count"><span class="cap-current"></span><span class="cap-total"></span></span>';
    kitMedia.appendChild(capEl);
    capIcon = capEl.querySelector(".cap-icon");
    capName = capEl.querySelector(".cap-name");
    capCur = capEl.querySelector(".cap-current");
    capTot = capEl.querySelector(".cap-total");
    setKitActive(0);
    if (reduce) {
      kitItems.forEach(function (el) {
        el.classList.add("is-active");
      });
    }
  }

  /* ---------------------------------------------------------------- */
  /*  Scroll-linked effects: hero parallax, word scrub, gallery pan   */
  /* ---------------------------------------------------------------- */
  var hero = document.querySelector(".hero");
  var heroBg = document.querySelector(".hero-bg");
  var heroInner = document.querySelector(".hero-inner");
  var statement = document.querySelector(".reveal-words");
  var words = statement ? statement.querySelectorAll(".word") : [];
  var gallery = document.querySelector("[data-gallery]");
  var galleryTrack = document.querySelector("[data-gallery-track]");
  var galleryDistance = 0;

  function measure() {
    if (galleryTrack && isDesktop()) {
      galleryDistance = Math.max(0, galleryTrack.scrollWidth - window.innerWidth);
    } else {
      galleryDistance = 0;
    }
  }
  measure();

  if (reduce && words.length) {
    Array.prototype.forEach.call(words, function (w) {
      w.style.opacity = "1";
    });
  }

  function update() {
    var sy = window.scrollY || window.pageYOffset || 0;
    var vh = window.innerHeight;
    var docH = (document.documentElement.scrollHeight || 0) - vh;

    if (header) header.classList.toggle("scrolled", sy > 24);
    if (bar) bar.style.transform = "scaleX(" + (docH > 0 ? clamp(sy / docH, 0, 1) : 0) + ")";

    if (reduce) return;

    /* Hero parallax + cinematic fade-out */
    if (hero && heroInner) {
      var hr = hero.getBoundingClientRect();
      var hp = clamp(-hr.top / vh, 0, 1);
      if (heroBg) heroBg.style.transform = "translateY(" + hp * 18 + "%) scale(" + (1 + hp * 0.12) + ")";
      heroInner.style.transform = "translateY(" + hp * 26 + "%)";
      heroInner.style.opacity = "" + clamp(1 - hp * 2, 0, 1);
    }

    /* Statement word-by-word scrub */
    if (statement && words.length) {
      var sr = statement.getBoundingClientRect();
      var start = vh * 0.85;
      var end = vh * 0.35;
      var p = clamp((start - sr.top) / (start - end), 0, 1);
      var n = words.length;
      for (var i = 0; i < n; i++) {
        var wp = clamp((p - i / n) / (1 / n), 0, 1);
        words[i].style.opacity = (0.14 + 0.86 * wp).toFixed(3);
      }
    }

    /* Gallery: vertical scroll drives horizontal pan (desktop) */
    if (gallery && galleryTrack) {
      if (isDesktop() && galleryDistance > 0) {
        var gr = gallery.getBoundingClientRect();
        var range = gr.height - vh;
        var gp = range > 0 ? clamp(-gr.top / range, 0, 1) : 0;
        galleryTrack.style.transform = "translateX(" + -gp * galleryDistance + "px)";
      } else {
        galleryTrack.style.transform = "";
      }
    }

    /* Kit: activate the inclusion nearest the viewport centre */
    if (kitItems.length && isDesktop()) {
      var kCenter = vh / 2, kBest = -1, kDist = Infinity;
      for (var ki = 0; ki < kitItems.length; ki++) {
        var kr = kitItems[ki].getBoundingClientRect();
        var kc = kr.top + kr.height / 2;
        var kd = Math.abs(kc - kCenter);
        if (kd < kDist) { kDist = kd; kBest = ki; }
      }
      if (kBest >= 0) setKitActive(kBest);
    }
  }

  /* rAF-throttled scroll handling */
  var ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () {
    measure();
    update();
  });

  /* ---------------------------------------------------------------- */
  /*  Lenis smooth scrolling (drives the effects when present)        */
  /* ---------------------------------------------------------------- */
  if (window.Lenis && !reduce) {
    var lenis = new window.Lenis({
      duration: 1.15,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      smoothWheel: true,
    });
    lenis.on("scroll", update);
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    document.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute("href");
      if (!id || id === "#") return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -80, duration: 1.2 });
      }
    });
  }

  update();
})();
